import css from './index.module.scss';
import createEFPic from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

const { EFPic } = createEFPic('/media/deltapro/pc/');

export default function Section19() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();
    return (
        <div
            className={`${css.section19} GtmModuleData-section`}
            data-section-id={css.section19}
            data-section-title={t.rich('section19_title', {
                line1: (child: string) => child,
            })}
        >
            <div className="wrapper">
                <div className="title">
                    {t.rich('section19_title', {
                        line1: (child: string) => <span className="color-green">{child}</span>,
                    })}
                </div>
                <div className="desc">{t('section19_desc')}</div>
                <div className="media-box">
                    <div className="video-box">
                        <EFVideo
                            sources={['/video/deltapro/solution.mp4', '/video/deltapro/solution.mp4']}
                            autoPlay={true}
                            loop={true}
                            preload={'auto'}
                            muted={true}
                            width={'100%'}
                            height={'100%'}
                        />
                    </div>
                    <div className="img-box">
                        <EFPic name={['19.webp', '19.jpg']} alt={t('section19_desc')} aria-label={t('section19_desc')} />
                    </div>
                </div>
                <div className="desc memo">{t('section19_desc2')}</div>
            </div>
        </div>
    );
}
